import React from 'react';
import { Row, Col } from 'reactstrap';
import { useTranslation } from 'react-i18next';

const OverviewHeader = ({ users, companies, tenants, roles, adminData }) => {
  const { t } = useTranslation();

  return (
    <div>
      <Row>
        <Col>
          <div className="content-heading">
            <div>
              Overview
              <small>{t('dashboard.WELCOME_BETA')}</small>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <h2>
            Backend version: <b>{adminData.backendVersion}</b>
          </h2>
        </Col>
      </Row>
      {/* START cards box */}
      <Row>
        <Col xl={3} md={6}>
          {/* START card */}
          <div className="card flex-row align-items-center align-items-stretch border-0">
            <div className="col-4 d-flex align-items-center bg-primary-dark justify-content-center rounded-left">
              <em className="icon-cloud-upload fa-3x"></em>
            </div>
            <div className="col-8 py-3 bg-primary rounded-right">
              <div className="h2 mt-0">{companies.length}</div>
              <div className="text-uppercase">Companies</div>
            </div>
          </div>
        </Col>
        <Col xl={3} md={6}>
          {/* START card */}
          <div className="card flex-row align-items-center align-items-stretch border-0">
            <div className="col-4 d-flex align-items-center bg-purple-dark justify-content-center rounded-left">
              <em className="icon-globe fa-3x"></em>
            </div>
            <div className="col-8 py-3 bg-purple rounded-right">
              <div className="h2 mt-0">
                {users.length}
                {/* <small>GB</small> */}
              </div>
              <div className="text-uppercase">Users</div>
            </div>
          </div>
        </Col>
        <Col xl={3} lg={6} md={12}>
          {/* START card */}
          <div className="card flex-row align-items-center align-items-stretch border-0">
            <div className="col-4 d-flex align-items-center bg-green-dark justify-content-center rounded-left">
              <em className="icon-bubbles fa-3x"></em>
            </div>
            <div className="col-8 py-3 bg-green rounded-right">
              <div className="h2 mt-0">{tenants.length}</div>
              <div className="text-uppercase">Tenants</div>
            </div>
          </div>
        </Col>
        <Col xl={3} md={6}>
          {/* START card */}
          <div className="card flex-row align-items-center align-items-stretch border-0">
            <div className="col-4 d-flex align-items-center bg-primary-dark justify-content-center rounded-left">
              <em className="icon-cloud-upload fa-3x"></em>
            </div>
            <div className="col-8 py-3 bg-primary rounded-right">
              <div className="h2 mt-0">{roles.length}</div>
              <div className="text-uppercase">Roles</div>
            </div>
          </div>
        </Col>
      </Row>
      {/* END cards box */}
    </div>
  );
};

export default OverviewHeader;
